/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleCarrierChangeRequest } from '../../models/article-carrier-change-request';
import { ArticleCarrierChangeResponse } from '../../models/article-carrier-change-response';
import { KeyType } from '../../models/key-type';

export interface PostCheckinArticleCarrier$Params {
  organizationSiteKey: KeyType;
  checkinKey: string;
  articleKey: KeyType;
      body: ArticleCarrierChangeRequest
}

export function postCheckinArticleCarrier(http: HttpClient, rootUrl: string, params: PostCheckinArticleCarrier$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleCarrierChangeResponse>> {
  const rb = new RequestBuilder(rootUrl, postCheckinArticleCarrier.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('checkinKey', params.checkinKey, {});
    rb.path('articleKey', params.articleKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleCarrierChangeResponse>;
    })
  );
}

postCheckinArticleCarrier.PATH = '/organization-sites/{organizationSiteKey}/consignee/checkins/{checkinKey}/article-carriers/{articleKey}';
